/* Empire Music navigation.
   The menu works without this file: it is built on <details>/<summary>, so
   click to open, stay open, and keyboard access are native browser behaviour.
   Without JavaScript the Products panel falls back to plain columns and the
   drawer to a 70vh panel, both perfectly usable. This file adds the two-pane
   layout and the niceties: one panel at a time, close on outside click, close
   on Escape, optional hover-to-open on the top bar, arrow keys, the scroll
   cues, and the drawer's full height measurement. */
(function () {
  var nav = document.querySelector('.empire-nav');
  if (!nav) return;

  var items = function () { return Array.prototype.slice.call(nav.querySelectorAll('.empire-nav__item')); };
  var closeAll = function (except) {
    items().forEach(function (d) { if (d !== except) d.open = false; });
  };

  /* ---------- 1. group each parent link with its own sub-list ----------
     The Liquid renders a parent link and its children as two sibling <li>s,
     which is fine for a plain column but splits them apart the moment the
     panel lays out in a grid. Move the sub-list inside its parent so the two
     always travel together. */
  function groupSublists() {
    nav.querySelectorAll('.empire-nav__subwrap').forEach(function (wrap) {
      var parent = wrap.previousElementSibling;
      var sub = wrap.querySelector('.empire-nav__sub');
      if (parent && sub) {
        parent.classList.add('empire-nav__group');
        parent.appendChild(sub);
        wrap.remove();
      }
    });
  }

  /* ---------- 2. scroll cue ----------
     A scrolling area that opens already full gives no sign that there is more
     below it. Each one gets a soft fade and a small label. The label is hidden
     outright when the contents already fit, and fades out on reaching the
     bottom. It never takes pointer events, so it cannot swallow a click meant
     for a link underneath.

     The wording comes from the Liquid, on the nav's data attributes, so it
     follows the storefront's language. */
  function addCue(scroller, variant, label) {
    if (!scroller || !scroller.parentNode) return function () {};

    var wrap = document.createElement('div');
    wrap.className = 'empire-nav__scrollwrap empire-nav__scrollwrap--' + variant;
    scroller.parentNode.insertBefore(wrap, scroller);
    wrap.appendChild(scroller);

    var cue = document.createElement('div');
    cue.className = 'empire-nav__cue';
    cue.setAttribute('aria-hidden', 'true');
    cue.hidden = true;

    var fade = document.createElement('span');
    fade.className = 'empire-nav__cue-fade';

    var pill = document.createElement('span');
    pill.className = 'empire-nav__cue-pill';
    var text = document.createElement('span');
    text.textContent = label;
    pill.appendChild(text);
    pill.insertAdjacentHTML(
      'beforeend',
      '<svg class="empire-nav__cue-arrow" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" focusable="false"><polyline points="6 9 12 15 18 9"></polyline></svg>'
    );

    cue.appendChild(fade);
    cue.appendChild(pill);
    wrap.appendChild(cue);

    var update = function () {
      var room = scroller.scrollHeight - scroller.clientHeight;
      if (room <= 12) {
        cue.hidden = true;
        return;
      }
      cue.hidden = false;
      var atEnd = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 8;
      cue.setAttribute('data-at-end', atEnd ? 'true' : 'false');
    };

    scroller.addEventListener('scroll', update, { passive: true });
    return update;
  }

  /* ---------- 3. two-pane layout for Products ----------
     Sixteen categories in one grid is a lot to scan, so Products gets a rail of
     category names on the left and that category's contents on the right.
     The rail switches on click only. Hovering does nothing, so running the
     pointer down the rail on the way to a link never swaps the contents out
     from under it. */
  function buildPane() {
    var products = nav.querySelector('.empire-nav__item[data-nav="products"]');
    if (!products) return;
    var cols = products.querySelector('.empire-nav__cols');
    if (!cols || cols.dataset.paned === 'true') return;

    var columns = Array.prototype.slice.call(cols.querySelectorAll(':scope > .empire-nav__col'));
    if (columns.length < 4) return;

    var pane = document.createElement('div');
    pane.className = 'empire-nav__pane';

    var rail = document.createElement('div');
    rail.className = 'empire-nav__rail';
    rail.setAttribute('role', 'tablist');
    rail.setAttribute('aria-label', 'Product categories');

    columns.forEach(function (col, i) {
      var head = col.querySelector('.empire-nav__head');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'empire-nav__railbtn';
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      btn.dataset.pane = String(i);
      btn.textContent = head ? head.textContent.trim() : 'More';
      rail.appendChild(btn);
      col.dataset.pane = String(i);
      col.classList.toggle('is-active', i === 0);
    });

    cols.parentNode.insertBefore(pane, cols);
    pane.appendChild(rail);
    pane.appendChild(cols);
    cols.classList.add('empire-nav__cols--pane');
    cols.dataset.paned = 'true';

    var updateColsCue = addCue(cols, 'pane', nav.dataset.scrollMore || 'Scroll for more');
    var updateRailCue = addCue(rail, 'rail', nav.dataset.scrollMoreShort || 'More');
    var refreshCues = function () { updateColsCue(); updateRailCue(); };

    function select(i) {
      rail.querySelectorAll('.empire-nav__railbtn').forEach(function (b) {
        b.setAttribute('aria-selected', b.dataset.pane === String(i) ? 'true' : 'false');
      });
      columns.forEach(function (c) { c.classList.toggle('is-active', c.dataset.pane === String(i)); });
      cols.scrollTop = 0;
      updateColsCue();
    }

    rail.addEventListener('click', function (e) {
      var btn = e.target.closest('.empire-nav__railbtn');
      if (btn) select(btn.dataset.pane);
    });

    rail.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      e.preventDefault();
      var btns = Array.prototype.slice.call(rail.querySelectorAll('.empire-nav__railbtn'));
      var i = btns.indexOf(document.activeElement);
      if (i < 0) return;
      btns[(i + (e.key === 'ArrowDown' ? 1 : btns.length - 1)) % btns.length].focus();
    });

    /* Reset to the first category each time the panel is opened. The cues can
       only be measured once the panel is on screen, so they are refreshed
       here rather than at load. */
    products.addEventListener('toggle', function () {
      if (products.open) {
        select(0);
        refreshCues();
      }
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        if (products.open) refreshCues();
      }, 150);
    });
  }

  /* ---------- 4. the drawer ----------
     The panel runs from under the header down to the bottom of the screen, so
     the account, cart and language controls sit at the foot rather than after
     a long scroll. Where the header ends depends on the announcement bar, the
     search band and whether the header has gone sticky, so it is measured on
     open rather than guessed. The links get the same scroll cue as the
     desktop panel. */
  function setUpDrawer() {
    var drawer = document.getElementById('EmpireDrawer');
    if (!drawer) return;
    var panel = drawer.querySelector('.empire-drawer__panel');
    var scroll = drawer.querySelector('.empire-drawer__scroll');
    if (!panel || !scroll) return;

    var updateCue = addCue(scroll, 'drawer', nav.dataset.scrollMore || 'Scroll for more');

    var fit = function () {
      if (!drawer.open) return;
      var top = panel.getBoundingClientRect().top;
      var room = Math.round(window.innerHeight - top);
      if (room < 240) room = 240;
      panel.style.setProperty('--empire-drawer-h', room + 'px');
      updateCue();
    };

    drawer.addEventListener('toggle', function () {
      if (drawer.open) fit();
    });

    /* A section opening or closing changes how much there is to scroll. */
    drawer.addEventListener('toggle', function (e) {
      if (e.target !== drawer && drawer.open) updateCue();
    }, true);

    var timer;
    window.addEventListener('resize', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(fit, 150);
    });
  }

  groupSublists();
  buildPane();
  setUpDrawer();

  /* ---------- 5. open and close behaviour ---------- */
  nav.addEventListener('click', function (e) {
    var summary = e.target.closest('.empire-nav__top');
    if (summary) closeAll(summary.parentElement);
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.empire-nav')) closeAll(null);
  });

  /* Hover-to-open applies to the top bar only, and only when the setting asks
     for it. The category rail inside Products is always click. */
  nav.addEventListener('mouseover', function (e) {
    if (nav.dataset.open !== 'hover') return;
    var summary = e.target.closest('.empire-nav__top');
    if (!summary) return;
    closeAll(summary.parentElement);
    summary.parentElement.open = true;
  });

  nav.addEventListener('mouseleave', function () {
    if (nav.dataset.open === 'hover') closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = nav.querySelector('.empire-nav__item[open]');
      if (open) {
        open.open = false;
        open.querySelector('.empire-nav__top').focus();
        return;
      }
      var drawer = document.getElementById('EmpireDrawer');
      if (drawer && drawer.open) drawer.open = false;
      return;
    }
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    var tops = items().map(function (d) { return d.querySelector('.empire-nav__top'); });
    var i = tops.indexOf(document.activeElement);
    if (i < 0) return;
    e.preventDefault();
    tops[(i + (e.key === 'ArrowRight' ? 1 : tops.length - 1)) % tops.length].focus();
  });

  var desktop = window.matchMedia('(min-width: 990px)');
  var sync = function () {
    var drawer = document.getElementById('EmpireDrawer');
    if (desktop.matches && drawer) drawer.open = false;
    if (!desktop.matches) closeAll(null);
  };
  if (desktop.addEventListener) {
    desktop.addEventListener('change', sync);
  } else if (desktop.addListener) {
    desktop.addListener(sync);
  }
})();